const validate = values => {
  const errors = {};
  if (!values.date) {
    errors.date = 'Favor informar a data combinada com o cliente!';
  }
  return errors;
};

export default validate;
